class oStoreLocatorFilters extends HTMLDivElement {
    constructor() {
        super();
        this.filters = this.querySelectorAll('.btn-filter');
        this.submitFilters = this.querySelector('.confirm-filters');
        this.resetBtn = this.querySelector('.btn-reset');
        this.filtersValue = this.querySelector('#department-filter-value');
        this.storeLocator = document.querySelector('[is="o-store-locator"]');
        this.sidebar = this.closest('[is="o-sidebar"]');

        this.confirmFilters = this.confirmFilters.bind(this);
        this.resetFilters = this.resetFilters.bind(this);
    }

    connectedCallback() {
        this.filters.forEach(filter => {
            filter.addEventListener('click', () => {
                this.toggleFilter(filter);
            });
        });
        this.resetBtn.addEventListener('click', this.resetFilters);
        this.submitFilters.addEventListener('click', this.confirmFilters);
    }

    resetFilters() {
        this.filters.forEach(filter => {
            filter.classList.remove('active');
        });
    }

    toggleFilter(filter) {
        filter.classList.toggle('active');
    }

    confirmFilters() {
        var selectedFilters = this.querySelectorAll('.btn-filter.active');
        this.filtersValue.value = '';
        selectedFilters.forEach(filter => {
            this.filtersValue.value += filter.value + ',';
        });
        this.filtersValue.value = this.filtersValue.value.slice(0, -1);
        this.storeLocator.dispatchEvent(new CustomEvent('storelocator:applyFilters', {
            detail: {
                filters: this.filtersValue.value ? this.filtersValue.value.split(',') : []
            }
        }));
        document.dispatchEvent(new CustomEvent('oSidebar:toggle', { detail: { sidebarId: this.sidebar.id, open: false } }));
    }
}

customElements.define('o-storelocator-filters', oStoreLocatorFilters, {
    extends: 'div'
});
